import { Box, Link, Typography } from '@mui/material'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import * as React from 'react'
import PropTypes from 'prop-types'

const getGoogleMapsUrl = (location) => {
  // Simple URL encoding for the location
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location)}`
}

export function GoogleLocation({ show }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, mt: 1 }}>
      <Link
        href={getGoogleMapsUrl(show.location)}
        target='_blank'
        rel='noopener noreferrer'
        sx={{ ml: 1, display: 'flex', alignItems: 'center' }}
      >
        <LocationOnIcon color='action' sx={{ mr: 1, fontSize: '1.1rem' }} />
        <Typography variant='body2' color='text.secondary' sx={{ flexGrow: 1 }}>
          {show.location}
        </Typography>
      </Link>
    </Box>
  )
}

GoogleLocation.propTypes = {
  show: PropTypes.shape({
    location: PropTypes.string
  }).isRequired
}
